import { Box, Button, Flex, Heading, Spinner, Stack, Text } from '@chakra-ui/react';
import { allTimezones, useTimezoneSelect } from 'react-timezone-select';

import { useInterviewAgent } from '@/store/InterviewAgent';
import { formatTimeFromTimestamp } from '@/utils';

export default function BeforeStartPage() {
  const { screening, candidate, nextStep } = useInterviewAgent();

  const { parseTimezone } = useTimezoneSelect({
    timezones: allTimezones,
    labelStyle: 'original'
  });

  if (!candidate || !screening) {
    return (
      <Flex flexDir="column" flexGrow={1} justify="center" align="center" minH="500px" w="100vw">
        <Spinner size="xl" mb="16px" color="primary.900" borderWidth="3px" />
        <Text color="gray.500" textAlign="center">
          Loading interview details...
        </Text>
      </Flex>
    );
  }

  return (
    <Flex
      mt="32px"
      flexDir="column"
      flexGrow={1}
      maxW="500px"
      mx="auto"
      justify="center"
      align="center"
      minH="calc(100vh - 240px)"
    >
      <Box w="100%">
        {/* Header */}
        <Heading size="lg" color="neutrals.900" fontSize="36px" mb="36px">
          Before you start
        </Heading>

        <Text fontSize="16px" color="neutrals.700" mb="32px" lineHeight="1.6">
          This is a digital interview to assess your initial fit for relevant roles. Your responses
          will be reviewed to help us make a more informed decision about your candidacy.
        </Text>

        {/* Interview Details Section */}
        <Box mb="48px">
          <Text fontSize="16px" color="neutrals.700" fontWeight="medium" mb="8px">
            Interview Details:
          </Text>
          <Stack gap="8px" pl="16px">
            <Text fontSize="16px" color="neutrals.700">
              • Deadline:{' '}
              <b>
                {formatTimeFromTimestamp(screening.deadline, screening.deadline_timezone)}{' '}
                {parseTimezone(screening.deadline_timezone).label}
              </b>
            </Text>
            <Text fontSize="16px" color="neutrals.700">
              • Duration: <b>{screening.session_time_limit} minutes (Maximum time allowed)</b>
            </Text>
            <Stack>
              <Text fontSize="16px" color="neutrals.700">
                • Description:
              </Text>
              <Box
                pl="12px"
                borderRadius="8px"
                bg="neutrals.50"
                minH="80px"
                h="100%"
                w="100%"
                p="12px"
              >
                <Text whiteSpace="pre-line">{screening.interview_description}</Text>
              </Box>
            </Stack>
          </Stack>
        </Box>

        {/* Action Button */}
        <Stack justify="center" align="center">
          <Button
            w="400px"
            bg="primary.900"
            color="white"
            onClick={nextStep}
            px="32px"
            py="16px"
            fontSize="16px"
            fontWeight="medium"
            borderRadius="8px"
            _hover={{
              bg: 'primary.700'
            }}
            transition="all 0.2s"
          >
            Next
          </Button>
        </Stack>
      </Box>
    </Flex>
  );
}
